'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocationCity = function MdLocationCity(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 25v-3.4h-3.2v3.4h3.2z m0 6.6v-3.2h-3.2v3.2h3.2z m-10-20v-3.2h-3.2v3.2h3.2z m0 6.8v-3.4h-3.2v3.4h3.2z m0 6.6v-3.4h-3.2v3.4h3.2z m0 6.6v-3.2h-3.2v3.2h3.2z m-10-13.2v-3.4h-3.2v3.4h3.2z m0 6.6v-3.4h-3.2v3.4h3.2z m0 6.6v-3.2h-3.2v3.2h3.2z m13.4-13.2h10v16.6h-30v-23.4h10v-3.2l5-5 5 5v10z' })
        )
    );
};

exports.default = MdLocationCity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/location-city.js
// module id = 3522
// module chunks = 168707334958949